<template>
  <div class="min-h-screen flex flex-col">
    <NavBar v-if="showNavBar" class="z-[9999999]" />
    <div class="flex-1">
      <RouterView />
    </div>
    <CartFooter v-if="showNavBar && showCartFooter" />
  </div>
  <ConfirmDialog></ConfirmDialog>
  <Toast class="!z-[9999999]" position="bottom-right"></Toast>
</template>

<script setup lang="ts">
import NavBar from '@/components/molecule/storekeeper/NavBar.vue'
import CartFooter from '@/components/organism/CartFooter.vue'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';

import { useUsers } from "@/features/users/controller";
const $userStore = useUsers();

import { useToast } from 'primevue/usetoast'
const toast = useToast()

import { RouterView, useRoute } from 'vue-router'
const route = useRoute()

const showNavBar = computed(() => {
  return $userStore.loggedUser && route.name !== 'login' && route.name !== 'activate-account' && route.name !== 'forgot-password' && route.name !== 'reset-password'
})

const showCartFooter = computed(() => {
  // Pour admin/storekeeper, il faut avoir sélectionné un utilisateur
  if ($userStore.isStorekeeper) {
    return !!(($userStore as any).selectedUserForShop)
  }
  // Pour les autres types d'utilisateurs, toujours afficher
  return true
})

onMounted(async () => {
});
</script>
